import { useState } from 'react';
import safeWindow from '../utils/safeWindows';

export function useLocalStorage<T>(key: string, initialValue: T, useSession?: boolean) {
  const storage = useSession ? safeWindow.sessionStorage : safeWindow.localStorage;

  const getValue = () => {
    try {
      const item = storage.getItem(key);

      return item ? (JSON.parse(item) as T) : initialValue;
    } catch {
      return initialValue;
    }
  };

  const [storedValue, setStoredValue] = useState<T>(getValue);

  const setValue = (value: T | ((val: T) => T)) => {
    const valueToStore =
      typeof value === 'function' ? (value as (val: T) => T)(storedValue) : value;

    setStoredValue(valueToStore);
    storage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue] as const;
}
